import { exportOrganisationRole, exportOrganisationRoles } from '@infuse/api/iam/organisation';
import { exportRole, exportRoles } from '@infuse/api/iam/role';
import { exportTenantRole, exportTenantRoles } from '@infuse/api/iam/tenant';
import { useCurrentUserStore } from '@infuse/iam/user/store';
import { UserLevel } from '@infuse/iam/user/type';
import { useGenericExportRoles } from './generic/useGenericExportRoles';

export const useExportRoles = (forcedLevel?: UserLevel, forcedParentId?: string) => {
  const { level, user } = useCurrentUserStore();

  if ((forcedLevel || level) === UserLevel.TENANT) {
    return useGenericExportRoles({
      exportOneFn: exportTenantRole,
      exportManyFn: exportTenantRoles,
      forcedParentId: forcedParentId || user?.tenantId
    });
  } else if ((forcedLevel || level) === UserLevel.ORGANISATION) {
    return useGenericExportRoles({
      exportOneFn: exportOrganisationRole,
      exportManyFn: exportOrganisationRoles,
      forcedParentId: forcedParentId || user?.organisationId
    });
  }

  return useGenericExportRoles({
    exportOneFn: exportRole,
    exportManyFn: exportRoles
  });
};
